import React, { useState, useEffect } from 'react';
import LoadDetail from './LoadDetail';
import GET_LOAD_DETAIL from '../../graphql/client/queries/getLoadDetail';
import { GetLoadDetail_getLoadDetail as LoadDetailData, GetLoadDetail } from '../../types/schemaTypes';
import { useQuery } from '@apollo/client/react';
import { Error, Loading } from '../_common';
import './LoadProfile.scss';
import DriverDetail from './DriverDetail';
import SplitLoadDriverDetail from './SplitLoadDriverDetail';
import AccessorialForLoadDetail from './AccessorialForLoadDetail';
import Button from 'react-bootstrap/Button';
import LoadProfileNav from './LoadProfileNav';
import { LoadStatusEnum } from '../../types/LoadStatusEnum';
import { Routes } from '../../utils';
import EditLoadDetail from '../EditLoad/EditLoadDetail';
import { Option } from '../Users/interface';
import { Link, useParams } from 'react-router-dom';
import { useAuthContext } from '../Auth/AuthProvider';
import { PermissionEnum } from '../../types/PermissionEnum';

const driverStatus: Option[] = [
    { id: 'Accepted', name: 'Accepted' },
    { id: 'Rejected', name: 'Rejected' },
    { id: 'Pending', name: 'Pending' },
];

const LoadProfile = ({ match }: any): React.ReactElement => {
    const [showModal, setShowModal] = useState(false);

    const handleOnClickHide = (): void => {
        setShowModal(false);
    };

    const {loadId} = useParams()
    const loadIdVal:any = loadId
    const variables = {
        loadId: parseInt(loadIdVal),
    };

    const [tabTitle, setTabTitle] = useState(document.title);
    const authContext = useAuthContext();
    const canViewLogs = authContext.userHasPermission(PermissionEnum.ViewLogs);
    const canEditLoadDetails = authContext.userHasPermission(PermissionEnum.EditLoadDetails);

    const { loading, error, data, refetch } = useQuery<GetLoadDetail>(GET_LOAD_DETAIL, {
        variables: variables,
        fetchPolicy: "cache-and-network"
    });

    const loadDetailData: LoadDetailData | null = data?.getLoadDetail || null;

    useEffect(() => {
        if (loadDetailData) {
            const loadJobName = loadDetailData.jobName ? loadDetailData.jobName : '';
            const loadLoadId = loadDetailData.loadId ? loadDetailData.loadId.toString() : tabTitle;

            document.title = loadJobName + ':' + loadLoadId;
            localStorage.setItem('loadHistory-JobName', loadJobName);
            setTabTitle(document.title);
        }
    }, [loadDetailData, tabTitle]);

    if (loading) {
        return <Loading />;
    }

    if (error) {
        return <Error error={error} />;
    }

    if (loadDetailData) {

                    // const loadJobName = loadDetailData && loadDetailData.jobName ? loadDetailData.jobName : '';
                    // const loadLoadId =
                    //     loadDetailData && loadDetailData.loadId ? loadDetailData.loadId.toString() : tabTitle;

                    // document.title = loadJobName + ':' + loadLoadId;
                    // localStorage.setItem('loadHistory-JobName', loadJobName);

                    // setTabTitle(document.title);

                    const loadDetailComponent = loadDetailData ? (
                        <LoadDetail
                            jobName={loadDetailData.jobName}
                            customerName={loadDetailData.customerName}
                            jdeNumber={loadDetailData.jdeNumber}
                            sandPo={loadDetailData.sandPO}
                            loadingFacility={loadDetailData.loadingFacility}
                            proppantType={loadDetailData.proppantName}
                            transportationPO={loadDetailData.transportationPo}
                            tmsId={loadDetailData.tmsId}
                        />
                    ) : (
                        <LoadDetail />
                    );

                    const driverDetailComponent = loadDetailData ? (
                        <DriverDetail
                            jobId={loadDetailData.jobId}
                            driver={loadDetailData.driverName}
                            carrier={loadDetailData.carrierName}
                            box={loadDetailData.isBellyDump? 'N/A': loadDetailData.boxNumber}
                            truck={loadDetailData.truckNumber}
                            chassis={loadDetailData.isBellyDump? 'N/A': loadDetailData.chassisNumber}
                            status={loadDetailData.status}
                            loadId={loadDetailData.loadId}
                            lofaId={loadDetailData.lofaId || 0}
                            regionId={loadDetailData.regionId || 0}
                            proppantName={loadDetailData.proppantName || ''}
                            sandPO={loadDetailData.sandPO}
                            driverStatus={loadDetailData.driverLoadStatus || ''}
                            driverId={loadDetailData.driverId || 0}
                            isSplit={loadDetailData.isSplit || false}
                            loadingFacility={loadDetailData.loadingFacility || ''}
                            jobName={loadDetailData.jobName || ''}
                            refetch={refetch}
                            secondaryDriverId={loadDetailData.secondaryDriverId || 0}
                        />
                    ) : (
                        <DriverDetail refetch={() => void 0} />
                    );

                    const splitLoadDriverDetailComponent = (
                        <SplitLoadDriverDetail
                            jobId={loadDetailData.jobId}
                            secondaryDriver={loadDetailData.secondaryDriverName}
                            secondaryCarrier={loadDetailData.secondaryCarrierName}
                            lofa={loadDetailData.loadingFacility}
                            box={loadDetailData.isBellyDump? 'N/A': loadDetailData.boxNumber}
                            secondaryTruck={loadDetailData.secondaryTruckNumber}
                            secondaryChassis={loadDetailData.isBellyDump? 'N/A': loadDetailData.secondaryChassisNumber}
                            status={loadDetailData.status}
                            loadId={loadDetailData.loadId}
                            lofaId={loadDetailData.lofaId}
                            regionId={loadDetailData.regionId || 0}
                            proppantName={loadDetailData.proppantName || ''}
                            sandPO={loadDetailData.sandPO}
                            secondaryDriverId={loadDetailData.secondaryDriverId || 0}
                            secondaryDriverStatus={loadDetailData.secondaryDriverLoadStatus || ''}
                            driver={loadDetailData.driverName || ''}
                            jobName={loadDetailData.jobName || ''}
                            refetch={refetch}
                        />
                    );

                    const checkForStatus = (): boolean => {
                        if (loadDetailData && loadDetailData.status === LoadStatusEnum.COMPLETED) {
                            setShowModal(false);
                            return true;
                        } else {
                            refetch();
                            setShowModal(true);
                        }
                        return false;
                    };

                    return (
                        <div className="LoadProfile-Container">
                            <div className="LoadProfile-Header">
                                <div className="LoadProfile-HeaderTitle">
                                    Load #{loadDetailData && loadDetailData.loadId}
                                    {(() => {
                                        if (loadDetailData.status === LoadStatusEnum.COMPLETED) {
                                            return (
                                                <div className="LoadProfile-CompleteLabel">
                                                    <i className="material-icons complete-icon-size">
                                                        check_circle_outline
                                                    </i>
                                                    <span className="complete-label">COMPLETED</span>
                                                </div>
                                            );
                                        } else if (loadDetailData.status === LoadStatusEnum.CANCELED) {
                                            return (
                                                <div className="LoadProfile-CompleteLabel">
                                                    <i className="material-icons complete-icon-size">cancel</i>
                                                    <span className="complete-label">CANCELED</span>
                                                </div>
                                            );
                                        } else {
                                            return <div></div>;
                                        }
                                    })()}
                                </div>
                                <div className="Row LoadProfile-ToggleButtonsContainer">
                                    <div className="LoadProfile-LeftToggleButton LoadProfile-ActiveButton">
                                        <p className="LoadProfile-ButtonText">Load Details</p>
                                    </div>
                                    <div
                                        className={`LoadProfile-RightToggleButton ${!canViewLogs &&
                                            'LoadProfile-RightToggleButton-Disabled'}`}
                                    >
                                        <Link
                                            to={`${Routes.LOAD_HISTORY.route}${variables.loadId}`}
                                            className="LoadProfile-ButtonText"
                                        >
                                            Load History
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="LoadProfile-LoadDetailsContainer">
                                <div className="LoadProfile-LoadDetails">
                                    {loadDetailComponent}
                                    {driverDetailComponent}
                                    {loadDetailData.isSplit === false ? '' : splitLoadDriverDetailComponent}
                                    <AccessorialForLoadDetail loadId={loadDetailData.loadId} />{' '}
                                    {canEditLoadDetails && (
                                        <div
                                            className={`LoadProfile-EditLink ${(loadDetailData.status ===
                                                LoadStatusEnum.COMPLETED &&
                                                'LoadProfile-EditLink-Disabled') ||
                                                (loadDetailData.status === LoadStatusEnum.CANCELED &&
                                                    'LoadProfile-EditLink-Disabled')}`}
                                        >
                                            <Button
                                                className="LoadProfile-Edit"
                                                variant="link"
                                                onClick={checkForStatus}
                                            >
                                                Edit
                                            </Button>
                                        </div>
                                    )}
                                    <EditLoadDetail
                                        onClickShow={() => setShowModal(true)}
                                        show={showModal}
                                        onClickHide={handleOnClickHide}
                                        loadId={loadDetailData.loadId}
                                        loadDetail={loadDetailData}
                                        driverStatus={driverStatus}
                                    />
                                </div>
                            </div>
                            <div className="LoadProfile-Nav">
                                <LoadProfileNav loadId={parseInt(loadIdVal)} loadDetail={loadDetailData} />
                            </div>
                        </div>
                    );
    } else {
        return <div></div>;
    }
};

export default LoadProfile;
